const options: any[] = [
    [{
        value: '>',
        options: [
            {
                value: '>',
                label: '>'
            }, {
                value: '≤',
                label: '≤'
            }
        ]
    }, {
        value: 1,
        options: [
            {
                value: 1,
                label: 1
            }
        ]
    }], [{
        value: '=',
        options: [
            {
                value: '=',
                label: '='
            }, {
                value: '≠',
                label: '≠'
            }
        ]
    }, {
        value: '是',
        options: [
            {
                value: '是',
                label: '生活费'
            }
        ]
    }], [{
        value: '=',
        options: [
            {
                value: '=',
                label: '≤'
            }
        ]
    }, {
        value: JSON.stringify({ attribute: '1102905983589425212', value: '是' }),
        options: [
            {
                value: JSON.stringify({ attribute: '1102905983589425212', value: '是' }),
                label: '30'
            }, {
                value: JSON.stringify({ attribute: '1102905983589425211', value: '是' }),
                label: '7'
            }
        ]
    }], [{
        value: '<',
        options: [
            {
                value: '<',
                label: '<'
            }
        ]
    }, {
        value: 300,
        options: [
            {
                value: 300,
                label: '300'
            }
        ]
    }], [{
        value: '>',
        options: [
            {
                value: '>',
                label: '>'
            }
        ]
    }, {
        value: 0,
        options: [
            {
                value: 0,
                label: '0'
            }
        ]
    }], [{
        value: '=',
        options: [
            {
                value: '=',
                label: '='
            }
        ]
    }, {
        value: '是',
        options: [
            {
                value: '是',
                label: '是'
            }, {
                value: '否',
                label: '否'
            }
        ]
    }], [{
        value: '=',
        options: [
            {
                value: '=',
                label: '='
            }
        ]
    }, {
        value: '否',
        options: [
            {
                value: '否',
                label: '不相符'
            }, {
                value: '是',
                label: '相符'
            }
        ]
    }]
];
export const SEARCH: any[] = [
    {
        type: 0,
        working: false,
        disabled: false,
        label: 'wifi关联人数',
        keys: ['1085149780876730441'],
        value: '1085149780876730441',
        options: options[0]
    },
    {
        type: 0,
        working: false,
        disabled: false,
        label: '手机号关联人数',
        keys: ['1085149780876730442'],
        value: '1085149780876730442',
        options: options[0]
    },
    {
        type: 0,
        working: false,
        disabled: false,
        label: '设备关联人数',
        keys: ['1085149780876730440'],
        value: '1085149780876730440',
        options: options[0]
    }, {
        type: 1,
        working: false,
        disabled: false,
        label: '用户',
        keys: ['1049202056725831719'],
        value: '1049202056725831719',
        options: options[1]
    }, {
        type: 1,
        working: true,
        disabled: false,
        label: '用户申请生活费时间',
        keys: ['1102905983589425211', '1102905983589425212'],
        value: '1102905983589425211',
        options: options[2]
    }, {
        type: 2,
        working: false,
        disabled: false,
        label: '申请生活费设备可信分',
        keys: ['2007c7e985bc7ee5eee52f3d2eebc610'],
        value: '2007c7e985bc7ee5eee52f3d2eebc610',
        options: options[3]
    }, {
        type: 1,
        working: false,
        disabled: false,
        label: '申请生活费前30min修改支付密码次数',
        keys: ['1102777549517246504'],
        value: '1102777549517246504',
        options: options[4]
    }, {
        type: 1,
        working: false,
        disabled: false,
        label: '申请生活费前30min找回支付密码次数',
        keys: ['1102777549517246505'],
        value: '1102777549517246505',
        options: options[4]
    }, {
        type: 1,
        working: false,
        disabled: false,
        label: '申请生活费前30min修改登录密码次数',
        keys: ['1103566224702316567'],
        value: '1103566224702316567',
        options: options[4]
    }, {
        type: 1,
        working: false,
        disabled: false,
        label: '申请生活费前30min找回登录密码次数',
        keys: ['1103566224702316568'],
        value: '1103566224702316568',
        options: options[4]
    }, {
        type: 1,
        working: false,
        disabled: false,
        label: '申请生活费前30min修改／换绑手机号次数',
        keys: ['1102777549517246510'],
        value: '1102777549517246510',
        options: options[4]
    }, {
        type: 1,
        working: false,
        disabled: false,
        label: '申请生活费授信后24h内绑定银行卡',
        keys: ['1102777549517246512'],
        value: '1102777549517246512',
        options: options[5]
    }, {
        type: 1,
        working: false,
        disabled: false,
        label: '申请生活费后24h内修改登录密码次数',
        keys: ['1103566224702316570'],
        value: '1103566224702316570',
        options: options[4]
    }, {
        type: 1,
        working: false,
        disabled: false,
        label: '申请生活费后24h内找回登录密码次数',
        keys: ['1103566224702316571'],
        value: '1103566224702316571',
        options: options[4]
    }, {
        type: 3,
        working: false,
        disabled: false,
        label: '在首次使用wifi上申请过生活费',
        keys: ['1102905983589425213'],
        value: '1102905983589425213',
        options: options[5]
    }, {
        type: 1,
        working: false,
        disabled: false,
        label: '生活费授信申请定位城市与常登陆城市',
        keys: ['1102777549517246521'],
        value: '1102777549517246521',
        options: options[6]
    }
];
